"use client";

import { useEffect, useState } from "react";
import { createClient } from "@/lib/supabase";
import type { Song } from "@/types/database";

export function useSongs() {
  const [data, setData] = useState<Song[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const supabase = createClient();
    supabase
      .from("songs")
      .select("*")
      .order("sort_order", { ascending: true })
      .then(({ data: rows }) => {
        setData((rows as Song[]) ?? []);
        setLoading(false);
      });
  }, []);

  return { data, loading };
}
